import { v4 as uuidv4 } from 'uuid';
import _ from 'lodash';
import store from '@/store/index';
export const BLANK_NEW_WORKFLOW_DATAS = [
  {
    id: uuidv4(),
    name: '',
    project: '',
    geo: '',
    requestType: '',
    mediaType: '',
    genre: '',
    keyword: '',
    slackId: '',
    primary: [],
    secondary: [],
    qc: [],
  },
];

export const prepareDataToCreateWorkflow = (payload) => {
  const user = store.getters["auth/user"];
  const assignments = store.getters["assignment/projectsList"];
  const nameList = [payload.project, payload.geo, payload.requestType, payload.mediaType, payload.genre, payload.keyword]
  const filteredList = nameList.filter(item => item !== undefined && item !== '' && item !== null);
  const WFName = filteredList.join('_');
  const data = {
    workflowName: payload.name ? payload.name : WFName,
    slackId: payload.slackId,
    projectId: assignments.find((el) => el.name === payload.project).id,
    geo: payload.geo,
    requestType: payload.requestType,
    mediaType: payload.mediaType,
    genre: payload.genre,
    keyword: payload.keyword,
    isArchived: false,
    addedResources: [],
    updatedResources: [],
    removedResourceIds: [],
    addedWorkflowHistoryRequests: [
      {
        updatedStatus: "Created",
        updatedById: user.user.id,
        comments: [
          "Created"
        ]
      }
    ],
  };
  payload.primary.forEach((el) => {
    data.addedResources.push({  
      resourceId: null,
      staffId: el.userId,
      workflowTier: `PRIMARY_TIER_${el.writerTier[1]}`,
      resourceRole: "PRIMARY"
    });
  })
  payload.secondary.forEach((el) => {
    data.addedResources.push({
      resourceId: null,
      staffId: el.userId,
      workflowTier: `SECONDARY_TIER_${el.editorTier[1]}`,
      resourceRole: "SECONDARY"
    });
  })
  payload.qc.forEach((el) => {
    data.addedResources.push({
      resourceId: null,
      staffId: el.userId,
      workflowTier: `QC_TIER_${el.qcTier[1]}`,
      resourceRole: "QC"
    });
  })
  return data;
}

export const modifyReceivedData = (payload) => {
  const staffList = store.getters["staff/gStaffList"];
  const retVal = [];

  payload.forEach((el) => {
    const workflowItem = {
      ...el,
      project: store.getters["assignment/projectsList"].find((item) => item.id === el.projectId).name,
      primary: [],
      secondary: [],
      qc: []
    };

    el.workflowResource.forEach((resource) => {
      const staffItem = staffList.find((item) => item.user.id === resource.staffId).user;
      switch (resource.resourceRole) {
        case "PRIMARY":
          workflowItem.primary.push({
            name: `${staffItem.firstName} ${staffItem.lastName}`,
            userId: resource.staffId,
            writerTier: `P${resource.workflowTier.split("_")[2]}`,
            editorTier: "",
            qcTier: "",
            resourceId: resource.resourceId
          });
          break;
        case "SECONDARY":
          workflowItem.secondary.push({
            name: `${staffItem.firstName} ${staffItem.lastName}`,
            userId: resource.staffId,
            writerTier: "",
            editorTier: `S${resource.workflowTier.split("_")[2]}`,
            qcTier: "",
            resourceId: resource.resourceId
          });
          break;
        case "QC":
          workflowItem.qc.push({
            name: `${staffItem.firstName} ${staffItem.lastName}`,
            userId: resource.staffId,
            writerTier: "",
            editorTier: "",
            qcTier: `Q${resource.workflowTier.split("_")[2]}`,
            resourceId: resource.resourceId
          });
          break;
      }
    });

    retVal.push(workflowItem);
  });
  const updatedOnToString = (updatedOn) => updatedOn.join('-');

  const groupWorkflowHistory = (workflowHistory) => {
    const groupedData = workflowHistory.reduce((acc, obj) => {
      const key = `${updatedOnToString(obj.updatedOn)}-${obj.updateStatus}-${obj.updatedBy}`;
      if (!acc[key]) {
        acc[key] = [];
      }
      acc[key].push(obj);
      return acc;
    }, {});
    return Object.values(groupedData);
  };

  retVal.forEach((workflowItem) => {
    if (workflowItem.workflowHistory) {
      workflowItem.groupedWorkflowHistory = groupWorkflowHistory(workflowItem.workflowHistory);
    }
  });
  
  return retVal;
};


export const prepareDataToUpdateWorkflow = (payload) => {
  const user = store.getters["auth/user"];
  const assignments = store.getters["assignment/projectsList"];
  const workflowClone = store.getters["workflow/gWorkflowClone"];
  const staffList = store.getters["staff/gStaffList"];
  const data = {
    workflowName: payload.name,
    slackId: payload.slackId,
    projectId: assignments.find((el) => el.name === payload.project).id,
    geo: payload.geo,
    requestType: payload.requestType,
    mediaType: payload.mediaType,
    genre: payload.genre,
    keyword: payload.keyword,
    isArchived: false,
    addedResources: [],
    updatedResources: [],
    removedResourceIds: [],
    addedWorkflowHistoryRequests: [],
  };
  payload.primary.forEach((el) => {
    const resource = workflowClone.workflowResource.find((item) => item.resourceId === el.resourceId);
    if (!resource || (resource && resource.resourceRole !== "PRIMARY")) {
      data.addedResources.push({  
        resourceId: null,
        staffId: el.userId,
        workflowTier: `PRIMARY_TIER_${el.writerTier[1]}`,
        resourceRole: "PRIMARY"
      });
      data.addedWorkflowHistoryRequests.push({
        updatedStatus: "Updated",
        updatedById: user.user.id,
        comments: [
          `${el.name} was added to workflow Primary tier`
        ]
      });
    }
    if (resource) {
      if (resource.resourceRole === "PRIMARY" && resource.workflowTier.split("_")[2] !== el.writerTier[1]) {
        data.updatedResources.push({
          resourceId: el.resourceId,
          staffId: el.userId,
          workflowTier: `PRIMARY_TIER_${el.writerTier[1]}`,
          resourceRole: "PRIMARY"
        });
        data.addedWorkflowHistoryRequests.push({
          updatedStatus: "Updated",
          updatedById: user.user.id,
          comments: [
            `Updated rating: ${el.name} (P${resource.workflowTier.split("_")[2]} > P${el.writerTier[1]})`
          ]
        });
      }
    }
  })
  
  payload.secondary.forEach((el) => {
    const resource = workflowClone.workflowResource.find((item) => item.resourceId === el.resourceId);
    if (!resource || (resource && resource.resourceRole !== "SECONDARY")) {
      data.addedResources.push({  
        resourceId: null,
        staffId: el.userId,
        workflowTier: `SECONDARY_TIER_${el.editorTier[1]}`,
        resourceRole: "SECONDARY"
      });
      data.addedWorkflowHistoryRequests.push({
        updatedStatus: "Updated",
        updatedById: user.user.id,
        comments: [
          `${el.name} was added to workflow Secondary tier`
        ]
      });
    }
    if (resource) {
      if (resource.resourceRole === "SECONDARY" && resource.workflowTier.split("_")[2] !== el.editorTier[1]) {
        data.updatedResources.push({
          resourceId: el.resourceId,
          staffId: el.userId,
          workflowTier: `SECONDARY_TIER_${el.editorTier[1]}`,
          resourceRole: "SECONDARY"
        });
        data.addedWorkflowHistoryRequests.push({
          updatedStatus: "Updated",
          updatedById: user.user.id,
          comments: [
            `Updated rating: ${el.name} (S${resource.workflowTier.split("_")[2]} > S${el.editorTier[1]})`
          ]
        });
      }
    }
  })

  payload.qc.forEach((el) => {
    const resource = workflowClone.workflowResource.find((item) => item.resourceId === el.resourceId);
    if (!resource || (resource && resource.resourceRole !== "QC")) {
      data.addedResources.push({  
        resourceId: null,
        staffId: el.userId,
        workflowTier: `QC_TIER_${el.qcTier[1]}`,
        resourceRole: "QC"
      });
      data.addedWorkflowHistoryRequests.push({
        updatedStatus: "Updated",
        updatedById: user.user.id,
        comments: [
          `${el.name} was added to workflow QC tier`
        ]
      });
    }
    if (resource) {
      if (resource.resourceRole === "QC" && resource.workflowTier.split("_")[2] !== el.qcTier[1]) {
        data.updatedResources.push({
          resourceId: el.resourceId,
          staffId: el.userId,
          workflowTier: `QC_TIER_${el.qcTier[1]}`,
          resourceRole: "QC"
        });
        data.addedWorkflowHistoryRequests.push({
          updatedStatus: "Updated",
          updatedById: user.user.id,
          comments: [
            `Updated rating: ${el.name} (Q${resource.workflowTier.split("_")[2]} > Q${el.qcTier[1]})`
          ]
        });
      }
    }
  })

  workflowClone.workflowResource.forEach((item) => {
    const payloadResources = [...payload.primary, ...payload.secondary, ...payload.qc];
    const resourceItem = payloadResources.find((el) => el.resourceId === item.resourceId);
    if (!resourceItem) {
      data.removedResourceIds.push(item.resourceId);
      data.addedWorkflowHistoryRequests.push({
        updatedStatus: "Updated",
        updatedById: user.user.id,
        comments: [
          `${staffList.find((el) => el.user.id === item.staffId).user.firstName} ${staffList.find((el) => el.user.id === item.staffId).user.lastName} was removed from workflow resources`
        ]
      });
    }
  })

  return data;
}